import { useEffect, useState } from 'react'

import { CHANGE_DEALER_CREDIT } from '../../../../utils/sockets'
import Button from '../../../../components/Button'
import Dialog from '../../../../components/Dialog'
import InputGroup from '../../../../components/InputGroup'

const DEFAULT_DTC_ONLY_CREDIT_COST = 0.5

const formatCredits = (value) => {
  return Number.isInteger(value) ? `${value}` : `${value}`
}

const ViewDealerCreditChangeDtcOnlyCostModal = (props) => {
  const { dtcCreditCostOverride, isOpen, setIsOpen, socket, onSuccess } = props

  const [newDtcCreditCostStr, setNewDtcCreditCostStr] = useState(
    typeof dtcCreditCostOverride === 'number' ? `${dtcCreditCostOverride}` : '',
  )
  const [newDtcCreditCost, setNewDtcCreditCost] = useState(
    typeof dtcCreditCostOverride === 'number' ? dtcCreditCostOverride : null,
  )
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      return
    }

    setSuccess(null)
    setError(null)
    setNewDtcCreditCostStr(
      typeof dtcCreditCostOverride === 'number'
        ? `${dtcCreditCostOverride}`
        : '',
    )
    setNewDtcCreditCost(
      typeof dtcCreditCostOverride === 'number' ? dtcCreditCostOverride : null,
    )
  }, [dtcCreditCostOverride, isOpen])

  const handleChange = (e) => {
    const input = e.target.value.replace(/[^0-9.]/g, '')

    setNewDtcCreditCostStr(input)

    if (!input) {
      setNewDtcCreditCost(null)
      return
    }

    const parsedValue = Number.parseFloat(input)
    setNewDtcCreditCost(Number.isNaN(parsedValue) ? null : parsedValue)
  }

  const handleSubmit = () => {
    setIsLoading(true)

    socket.emit(
      CHANGE_DEALER_CREDIT,
      { dtcCreditCostOverride: newDtcCreditCost },
      (err, dealerCredit) => {
        setIsLoading(false)

        if (dealerCredit) {
          setSuccess(true)
          onSuccess(dealerCredit)
          return
        }

        if (err) {
          setError(err)
        }
      },
    )
  }

  if (error) {
    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="An error occurred"
        buttonProps={null}
      >
        <p className="text-gray-600 text-sm mt-2">
          There was an error saving the DTC-only credit cost.
        </p>
        <Button className="mt-4" onClick={setIsOpen}>
          Finish and close
        </Button>
      </Dialog>
    )
  }

  if (success) {
    const effectiveCost =
      typeof newDtcCreditCost === 'number'
        ? newDtcCreditCost
        : DEFAULT_DTC_ONLY_CREDIT_COST

    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="DTC-only credit cost changed"
        buttonProps={null}
      >
        <p className="text-gray-600 text-sm mt-2">
          We have successfully set the subdealer DTC-only credit cost to{' '}
          {formatCredits(effectiveCost)} credit
          {effectiveCost === 1 ? '' : 's'}.
        </p>
        <Button className="mt-4" onClick={setIsOpen}>
          Finish and close
        </Button>
      </Dialog>
    )
  }

  return (
    <Dialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Change DTC-only credit cost"
      buttonProps={{
        disabled:
          isLoading ||
          (newDtcCreditCostStr !== '' &&
            (newDtcCreditCost === null || newDtcCreditCost < 0)),
        onClick: handleSubmit,
        children: isLoading ? 'Saving...' : 'Save credit cost',
        color: 'primary',
      }}
    >
      <div className="mt-2">
        <InputGroup
          label="New DTC-only credit cost override"
          id="dtcCreditCostOverride"
          disabled={isLoading}
          onChange={handleChange}
          value={newDtcCreditCostStr}
          help={`Leave blank to use the default ${DEFAULT_DTC_ONLY_CREDIT_COST} credits. Recommended to have cost in 0.25 credit increments.`}
        />
      </div>
    </Dialog>
  )
}

export default ViewDealerCreditChangeDtcOnlyCostModal
